import { useParams } from 'react-router-dom';
import { ManagementSection } from './ManagementSection';
import { VenueWinesManagement } from '../../components/VenueWinesManagement';

export const WineManagementSection = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <ManagementSection
      title="Manage Wines"
      description="Add, edit, and organize your venue's wine collection. Manage wine details, pricing, availability, and tasting notes."
      status="active"
    >
      <VenueWinesManagement venueId={id || ''} />
    </ManagementSection>
  );
};